module.exports = __webpack_public_path__ + "static/media/YB5F08_4.bec04d10.jpg";